import { Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
  selector: 'app-preview-dialog',
  standalone: true,
  imports: [],
  templateUrl: './preview-dialog.component.html',
  styleUrl: './preview-dialog.component.scss'
})
export class PreviewDialogComponent {
  dialogRef = inject(MatDialogRef<PreviewDialogComponent>);
  data = inject(MAT_DIALOG_DATA);
  protected CDN = inject('CDN' as any) as string;


  close(): void {
    this.dialogRef.close();
  }

  onImageError(event: any): void {
    console.error('Error loading image: ', event);
  }
}
